export default __webpack_public_path__ + "static/media/300_en.e8139a4a.xls";